/** Normalized view-model the shared ProductDetailDrawer renders. Each consumer maps its own
 * data (a standards product, an order line + enrichment, a quote line, a catalog product) into
 * this shape. Field names mirror the ProductDetailDto/drawer enrichment payloads. */
export interface ProductDrawerViewModel {
  productName?: string | null;
  mfrPartNum?: string | null;
  shiPartNumber?: string | null;
  productDescriptor?: string | null;
  price?: number | null;
  description?: string | null;
  parsedDescriptionsList?: string[] | null;
  category?: string | null;
  mediaClass?: string | null;
  manufacturer?: string | null;
  msrp?: number | null;
  unspsc?: string | null;
  inventoryStatus?: string | null;
  productClass?: string | null;
  canAddToCart?: boolean | null;
  containedInCatalog?: boolean | null;
  /** False when the catalog returned no detail for this product. */
  hasCatalogDetail?: boolean;
}

export interface DrawerImage {
  url: string;
  alt: string;
}

export interface ProductDrawerSpecification {
  dimensions?: string | null;
  weight?: string | null;
}

/** Single stock-availability row. Structural so both the customer-experience
 * ProductAvailabilityResponse and the customer-success widened availability data satisfy it. */
export interface StockInventoryRow {
  rowType?: number | string | null;
  location?: string | null;
  inStock?: number | null;
  onOrder?: number | null;
  onOrderEta?: Date | string | null;
}

export interface StockInventoryData {
  productAvailability?: StockInventoryRow[] | null;
}

/** Optional add-to-cart capability. Omit for read-only consumers (orders, quotes, IT projects). */
export interface ProductDrawerCartConfig {
  canAddToCart: boolean;
  /** Shown as a tooltip on the disabled Add to Cart button. */
  disabledReason?: string | null;
  onAddToCart: (quantity: number) => void;
}

/** Optional Stock / Inventory tab capability. Omit to render the drawer as a single panel. */
export interface ProductDrawerStockTabConfig {
  data: StockInventoryData | null;
  isLoading: boolean;
  isError: boolean;
  onRefresh: () => void;
}

export const ProductDrawerTab = {
  ProductDetails: 0,
  StockInventory: 1,
} as const;
export type ProductDrawerTab =
  (typeof ProductDrawerTab)[keyof typeof ProductDrawerTab];
